<!-- eslint-disable -->
<template lang="pug">
    .browse-games__container
        .browse-games
            .browse-games__box(v-if="isMobile && isDisabledOnMobile")
                .warning
                    svg(
                        version="1.1" id="rotate" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                        width="40px" height="40px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
                        xml:space="preserve"
                    )
                        no-phone-icon
                    div {{ $i18n.t('trainer.trainer_games_gameForDesktopOnly') }}
                    router-link.back-button(:to="{name: 'dashboard'}", v-focus="true")
                        cs-button  {{ $i18n.t('trainer.trainer_browseGames_back') }}
            template(v-else-if="doesntHaveOldUncompletedHomework && !isHomeworkLoading && isAvailableHomework")
                template(v-if="!isLoading && parameters")
                    template(v-if="!exerciseId && paramsArray && paramsArray.length > 1")
                        .browse-games__box
                            .settings-container(v-for="(params, index) in paramsArray")
                                .settings
                                    .settings-header(:style="{color: colorsForStudents[index]}")
                                        | {{ params.playerName }}
                                    div(
                                        :is="getType(type)",
                                        :parameters="params",
                                        :exercise-id="exerciseId",
                                        @start="$emit('start')",
                                        :type="type",
                                    )
                    .browse-games__one-player(v-else)
                        .browse-games__header(:class="[isOlympiad && 'browse-games__header--no-padding']")
                            h2.browse-games__header-text {{ $i18n.t(`common.common_gameName_${getTranslationKey()}` )}}
                        div(
                            :is="getType(type)",
                            :parameters="parameters",
                            :exercise-id="exerciseId",
                            @start="$emit('start')",
                            :type="type",
                        )
                        .browse-games__buttons-container
                            cs-button(
                                @click="$emit('start')",
                                v-if="isOlympiad",
                                v-focus="true"
                            ) {{ $i18n.t('trainer.trainer_browseGames_play') }}
                            .buttons(v-else)
                                cs-button(
                                    color="blue"
                                    @click="$router.push(route)"
                                    v-focus="true"
                                ) {{ $i18n.t('trainer.trainer_browseGames_play') }}
                                tip-button.tip-button(
                                    v-if="isBonusGames"
                                    :is-for-bonus-games="true"
                                    :arrow-icon-rotated="showTip"
                                    @toggle-show-tip-variable="toggleShowTipVariable"
                                )
                                draggable(v-if="showTip")
                                    tips.tips(
                                        :tips="tipsForCurrentParameters",
                                        @toggle-show-tip-variable="toggleShowTipVariable"
                                    )
                    cs-button(
                        v-if="!exerciseId && paramsArray && paramsArray.length > 1"
                        color="blue"
                        @click="$router.push(route)",
                        v-focus="true"
                    ) {{ $i18n.t('trainer.trainer_browseGames_play') }}
                cs-loader(v-else)
            cs-loader(v-else)
            box.browse-games__box-message(v-else-if="!doesntHaveOldUncompletedHomework && !isHomeworkLoading")
                .browse-games__header-text_green
                    | {{ $i18n.t('trainer.trainer_browseGames_hello') }}
                    | {{ $i18n.t('trainer.trainer_browseGames_noHomeworkAccess') }}
                router-link.back-button(:to="{name: 'dashboard'}", v-focus="true")
                    cs-button  {{ $i18n.t('trainer.trainer_browseGames_back') }}
            box(
                v-else-if="!isAvailableHomework && !isHomeworkLoading"
            ) {{ $i18n.t('trainer.trainer_browseGames_noDayAccess') }}
</template>

<script>
    /*eslint-disable*/
    import GameExerciseApi from '../../../api/games/gameExercise';
    import { mapState } from 'vuex';
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import moment from 'moment';
    import Tips from '../games/Tips.vue';
    import TipButton from '../games/TipButton.vue';
    const FlashCards = () => import('./FlashCards.vue');
    const Diada = () => import('./Diada.vue');
    const AdditionAndSubtraction = () => import('./AddSub.vue');
    const Expressions = () => import('./Expressions.vue');
    const MultiplicationAndDivision = () => import('./MultiplicationAndDivision.vue');
    const TabularMultiplication = () => import('./TabularMultiplication.vue');
    const Equation = () => import('./Equation.vue');
    const Factorization = () => import('./Factorization.vue');
    const EquationMultiplication = () => import('./EquationMultiplication.vue');
    const EquationOnline = () => import('./EquationOnline.vue');
    const Anzan = () => import('./Anzan.vue');
    const Puzzle = () => import('./Puzzle.vue');
    const Couples = () => import('./Couples.vue');
    const WordsField = () => import('./WordsField.vue');
    const WordsFieldReadingEn = () => import('./WordsFieldReadingEn.vue');
    const Chains = () => import('./Chains.vue');
    const Schulte = () => import('./Schulte.vue');
    const AssembleTheNumber = () => import('./AssembleTheNumber.vue');
    const SequenceOfNumbers = () => import('./SequenceOfNumbers.vue');
    const Scanner = () => import('./Scanner.vue');
    const Shutter = () => import('./Shutter.vue');
    const ShutterReadingEn = () => import('./ShutterReadingEn.vue');
    const ShutterRussianLanguage = () => import('./ShutterRussianLanguage.vue');
    const Anagrams = () => import('./Anagrams.vue');
    const Texts = () => import('./Texts.vue');
    const CatchWord = () => import('./CatchWord.vue');
    const CatchWordReadingEn = () => import('./CatchWordReadingEn.vue');
    const LettersField = () => import('./LettersField.vue');
    const VisionField = () => import('./VisionField.vue');
    const VisionFieldReadingEn = () => import('./VisionFieldReadingEn.vue');
    const Navigator = () => import('./Navigator.vue');
    const NavigatorBonusGames = () => import('./Navigator.vue');
    const Matrix = () => import('./Matrix.vue');
    import MobileDetect from 'mobile-detect/mobile-detect.js';
    import NoPhoneIcon from '../../svg/NoPhone.vue';
    const Synonyms = () => import('./Synonyms.vue');
    const SynonymsReadingEn = () => import('./SynonymsReadingEn.vue');
    const SynonymsRussianLanguage = () => import('./SynonymsRussianLanguage.vue');
    const AntonymsRussianLanguage = () => import('./AntonymsRussianLanguage.vue');
    const Presentations = () => import('./Presentations.vue');
    const Antonyms = () => import('./Antonyms.vue');
    const Search = () => import('./Search.vue');
    const Classifications = () => import('./Classifications.vue');
    const SoundCouples = () => import('./SoundCouples.vue');
    const FourthOne = () => import('./FourthOne.vue');
    const DigitCouples = () => import('./DigitCouples.vue');
    const Memory = () => import('./Memory.vue');
    const RootsAndDegrees = () => import('./RootsAndDegrees.vue');
    const DayOfWeek = () => import('./DayOfWeek.vue');
    const MultiplicationAndDivisionMathMagic = () => import('./MultiplicationAndDivisionMathMagic.vue');
    const RootsAndSquares = () => import('./RootsAndSquares.vue');
    const Memorize = () => import('./Memorize.vue');
    const KeenEye = () => import('./KeenEye.vue');
    const KeenEyeBonusGames = () => import('./KeenEye.vue');
    const NumericalNetwork = () => import('./NumericalNetwork.vue');
    const Loner = () => import('./Loner');
    const LonerBonusGames = () => import('./LonerBonusGames');
    const Memo = () => import('./Memo.vue');
    const MemoBonusGames = () => import('./Memo.vue');
    const MemoryX = () => import('./MemoryX.vue');
    const RevivedNumbers = () => import('./RevivedNumbers.vue');
    const Associations = () => import('./Associations.vue');
    const WhoIsWho = () => import('./WhoIsWho.vue');
    const CosmoTour = () => import('./CosmoTour.vue');
    const SecretsOfCicero = () => import('./SecretsOfCicero.vue');
    const VocabularyWords = () => import('./VocabularyWords.vue');
    const VocabularyMemo = () => import('./VocabularyMemo.vue');
    const MentalDrawing = () => import('./MentalDrawing.vue');
    const HandsUp = () => import('./HandsUp.vue');
    const Chameleon = () => import('./Chameleon.vue');
    const RepeatAfterMe = () => import('./RepeatAfterMe.vue');
    const CorrectiveSamples = () => import('./CorrectiveSamples.vue');
    const Scout = () => import('./Scout.vue');
    const Alpari = () => import('./Alpari.vue');
    const ChainsBonusGame = () => import('./ChainsBonusGame.vue');
    const ChainsReadingEn = () => import('./ChainsReadingEn.vue');
    const CouplesReadingEn = () => import('./CouplesReadingEn.vue');
    const DivideItRight = () => import('./DivideItRight.vue')
    const ChooseItRight = () => import('./ChooseItRight.vue');
    const DivideUnstressedVowels = () => import('./DivideUnstressedVowels.vue');
    const WordStructure = () => import('./WordStructure.vue');
    const SentenceParsing = () => import('./SentenceParsing.vue');
    const VocabularyWordsRus = () => import('./VocabularyWordsRus.vue');
    const WordDrum = () => import('./WordDrum.vue');
    const LettersSoundsSyllables = () => import('./LettersSoundsSyllables.vue');
    const TransferSyllables = () => import('./TransferSyllables.vue');
    const TransferSyllablesSchoolPreparing = () => import('./TransferSyllablesSchoolPreparing.vue');
    const HardSoftConsonants = () => import('./HardSoftConsonants.vue');
    const HardSoftConsonantsSchoolPreparing = () => import('./HardSoftConsonantsSchoolPreparing.vue');
    const VocabularyMemoRus = () => import('./VocabularyMemoRus.vue');
    const Orthograph = () => import('./Orthograph.vue');
    const TranscriptionInWord = () => import('./TranscriptionInWord.vue');
    const VoicedAndDeafConsonants = () => import('./VoicedAndDeafConsonants.vue');
    const PartsOfSpeech = () => import('./PartsOfSpeech.vue');
    const ParsingSentencePartsSpeech = () => import('./ParsingSentencePartsSpeech.vue');
    const SortOneMany = () => import('./SortOneMany.vue');
    const GenericWords = () => import('./GenericWords.vue');
    const VerbTenses = () => import('./VerbTenses.vue');
    const PunctuationMarks = () => import('./PunctuationMarks.vue');
    const Alphabet = () => import('./Alphabet.vue');
    const ConnectThePuzzles = () => import('./ConnectThePuzzles.vue');

    import getType from '../../../utils/trainer/getType';
    import getBase64FromUrl from '../../../utils/getBase64FromUrl';
    import _ from 'lodash';
    import HomeworkApi from '../../../api/homework/homework';
    import getTipsForCurrentParameters from '../../../utils/trainer/getTipsForCurrentParameters';
    import { TARIFF_IDS_WITH_PLAY_TIME_LIMIT } from '@/config/tariff_constants';

    const GAMES_DISABLED_ON_MOBILE = ['VisionField', 'Matrix', 'Search', 'Classifications', 'Memory', 'Memorize'];

    export default {
        data() {
            return {
                showTip: false,
                parameters: null,
                isLoading: false,
                exercise: null,
                isHomeworkLoading: true,
                isMobile: false,
                isDisabledOnMobile: false,
                uncompletedHomeworksTypes: [],
                homeworks: [],
                colorsForStudents: [
                    '#6BBD6C',
                    '#2187FF',
                    '#FF7245',
                    '#FFAD1F',
                    '#FF5DAB',
                    '#42D29E',
                    '#BB6BD9',
                    '#56CCF2',
                ],
                afterInit: false,
            };
        },
        components: {
            Tips,
            TipButton,
            FlashCards,
            AdditionAndSubtraction,
            MultiplicationAndDivision,
            Equation,
            Factorization,
            EquationMultiplication,
            EquationOnline,
            Anzan,
            Puzzle,
            Couples,
            Chains,
            Schulte,
            AssembleTheNumber,
            SequenceOfNumbers,
            Scanner,
            Expressions,
            WordsField,
            WordsFieldReadingEn,
            Shutter,
            ShutterRussianLanguage,
            ShutterReadingEn,
            Anagrams,
            Texts,
            CatchWord,
            CatchWordReadingEn,
            LettersField,
            VisionField,
            VisionFieldReadingEn,
            Navigator,
            ConnectThePuzzles,
            NavigatorBonusGames,
            Matrix,
            NoPhoneIcon,
            Synonyms,
            SynonymsReadingEn,
            SynonymsRussianLanguage,
            AntonymsRussianLanguage,
            Presentations,
            Antonyms,
            Search,
            Classifications,
            SoundCouples,
            FourthOne,
            DigitCouples,
            Memory,
            Memorize,
            KeenEye,
            KeenEyeBonusGames,
            NumericalNetwork,
            RootsAndDegrees,
            MultiplicationAndDivisionMathMagic,
            TabularMultiplication,
            RootsAndSquares,
            DayOfWeek,
            Loner,
            LonerBonusGames,
            Memo,
            MemoBonusGames,
            MemoryX,
            RevivedNumbers,
            Associations,
            WhoIsWho,
            SecretsOfCicero,
            VocabularyWords,
            VocabularyMemo,
            CosmoTour,
            MentalDrawing,
            HandsUp,
            Chameleon,
            RepeatAfterMe,
            CorrectiveSamples,
            ChainsBonusGame,
            Scout,
            Diada,
            Alpari,
            ChainsReadingEn,
            CouplesReadingEn,
            TransferSyllables,
            TransferSyllablesSchoolPreparing,
            HardSoftConsonants,
            HardSoftConsonantsSchoolPreparing,
            VocabularyMemoRus,
            Orthograph,
            TranscriptionInWord,
            Alphabet,
            DivideItRight,
            ChooseItRight,
            DivideUnstressedVowels,
            WordStructure,
            SentenceParsing,
            VocabularyWordsRus,
            WordDrum,
            LettersSoundsSyllables,
            VoicedAndDeafConsonants,
            PartsOfSpeech,
            ParsingSentencePartsSpeech,
            GenericWords,
            VerbTenses,
            SortOneMany,
            PunctuationMarks,
        },
        props: ['exerciseId', 'homeworkId', 'type', 'isOlympiad', 'courseType', 'sameSettingsAreActive'],
        beforeRouteEnter(to, from, next) {
            next(self => {
                if (from.params.courseType) {
                    to.params.courseType = from.params.courseType;
                }
            });
        },
        watch: {
            parameters: {
                handler() {
                    this.tipsForCurrentParameters = getTipsForCurrentParameters(_.cloneDeep(this.parameters));
                },
                deep: true,
                immediate: true,
            },
            isFreeGamePlaytimeLimitIssue(val) {
                if (this.afterInit && val) {
                    this.$router.replace({ name: 'user:playtime-ended' });
                }
            }
        },
        async mounted() {
            this.isMobile = Boolean(new MobileDetect(window.navigator.userAgent).phone());

            await this.fetchData();

            if (!this.$offline) {
                try {
                    await this.$store.dispatch('setUserByToken');
                } catch (err) {
                    this.$toasted.error(this.$root.$t('errors.getting_user'));
                }
            }

            this.afterInit = true;

            if (this.isFreeGamePlaytimeLimitIssue) {
                this.$router.replace({ name: 'user:playtime-ended' });
                return;
            }

            this.$createjs.Sound.registerSounds([{ id: 'beep', src: '/sounds/countdown/beep.ogg' }]);
        },
        mixins: [TrainerUtilities, getType, getBase64FromUrl],
        methods: {
            toggleShowTipVariable() {
                this.showTip = !this.showTip;
            },
            getTranslationKey() {
                switch (this.type) {
                    case 'MultiplicationAndDivision':
                    case 'MultiplicationAndDivisionMathMagic':
                    case 'TabularMultiplication':
                    case 'FlashCards':
                    case 'Puzzle':
                    case 'AdditionAndSubtraction':
                    case 'Equation':
                    case 'Factorization':
                    case 'CatchWord':
                    case 'LettersField':
                    case 'VisionField':
                    case 'Presentations':
                    case 'Antonyms':
                    case 'SoundCouples':
                    case 'DigitCouples':
                    case 'Expressions':
                    case 'DivideItRight':
                    case 'ChooseItRight':
                    case 'DivideUnstressedVowels':
                    case 'WordStructure':
                    case 'SentenceParsing':
                    case 'VocabularyWordsRus':
                    case 'WordDrum':
                    case 'LettersSoundsSyllables':
                    case 'TransferSyllables':
                    case 'TransferSyllablesSchoolPreparing':
                    case 'HardSoftConsonants':
                    case 'HardSoftConsonantsSchoolPreparing':
                    case 'VocabularyMemoRus':
                    case 'Orthograph':
                    case 'TranscriptionInWord':
                    case 'VoicedAndDeafConsonants':
                    case 'PartsOfSpeech':
                    case 'ParsingSentencePartsSpeech':
                    case 'GenericWords':
                    case 'VerbTenses':
                    case 'SortOneMany':
                    case 'PunctuationMarks':
                    case 'AntonymsRussianLanguage':
                        return _.camelCase(this.type);
                    case 'Navigator':
                    case 'NavigatorBonusGames':
                        return 'navigator';
                    case 'EquationOnline':
                        return 'equationOnline';
                    case 'InteractiveFlashCards':
                        return 'flashCards';
                    case 'AdditionAndSubtractionWithTime':
                    case 'AdditionAndSubtractionMathMagic':
                        return 'additionAndSubtraction';
                    case 'Anzan':
                        return 'anzan';
                    case 'AnzanWithTime':
                        return 'anzanWithTime';
                    case 'ShutterRussianLanguage':
                        return 'shutterRussianLanguage';
                    case 'Couples':
                    case 'CouplesWithTime':
                    case 'CouplesMemoryDevelopment':
                    case 'CouplesMemoryDevelopmentWithTime':
                        return 'couples';
                    case 'Chains':
                    case 'ChainsWithTime':
                        return 'chains';
                    case 'Matrix':
                    case 'MatrixWithTime':
                        return 'matrix';
                    case 'Schulte':
                        return 'schulte';
                    case 'AssembleTheNumber':
                        return 'assembleTheNumber';
                    case 'SequenceOfNumbers':
                        return 'sequenceOfNumbers';
                    case 'Scanner':
                    case 'ScannerWithTime':
                        return 'scanner';
                    case 'Shutter':
                    case 'ShutterOnline':
                    case 'ShutterReadingEn':
                        return 'shutter';
                    case 'WordsField':
                    case 'WordsFieldWithTime':
                    case 'WordsFieldOnline':
                    case 'WordsFieldOnlineWithTime':
                    case 'WordsFieldReadingEn':
                    case 'WordsFieldReadingEnWithTime':
                        return 'wordsField';
                    case 'Anagrams':
                    case 'AnagramsWithTime':
                    case 'AnagramsOnline':
                    case 'AnagramsOnlineWithTime':
                        return 'anagrams';
                    case 'Texts':
                    case 'TextsWithTime':
                    case 'TextsOnline':
                    case 'TextsOnlineWithTime':
                        return 'texts';
                    case 'Synonyms':
                    case 'SynonymsOnline':
                    case 'SynonymsReadingEn':
                    case 'SynonymsRussianLanguage':
                        return 'synonyms';
                    case 'Search':
                        return 'search';
                    case 'Classifications':
                        return 'classifications';
                    case 'CatchWordOnline':
                    case 'CatchWordReadingEn':
                        return 'catchWord';
                    case 'FourthOne':
                        return 'fourthOne';
                    case 'Memory':
                        return 'memory';
                    case 'Memorize':
                        return 'memorize';
                    case 'KeenEye':
                    case 'KeenEyeBonusGames':
                        return 'keenEye';
                    case 'NumericalNetwork':
                        return 'numericalNetwork';
                    case 'RootsAndDegrees':
                        return 'rootsAndDegrees';
                    case 'LettersFieldOnline':
                        return 'lettersField';
                    case 'DayOfWeek':
                        return 'dayOfWeek';
                    case 'RootsAndSquares':
                        return 'rootsAndSquares';
                    case 'Loner':
                    case 'LonerBonusGames':
                        return 'loner';
                    case 'Memo':
                    case 'MemoBonusGames':
                        return 'memo';
                    case 'MemoryX':
                        return 'memoryX';
                    case 'RevivedNumbers':
                        return 'revivedNumbers';
                    case 'Associations':
                        return 'associations';
                    case 'WhoIsWho':
                    case 'WhoIsWhoWithTime':
                        return 'whoIsWho';
                    case 'SecretsOfCicero':
                        return 'secretsOfCicero';
                    case 'VocabularyWords':
                        return 'vocabularyWords';
                    case 'VocabularyMemo':
                        return 'vocabularyMemo';
                    case 'CosmoTour':
                        return 'cosmoTour';
                    case 'MentalDrawing':
                        return 'mentalDrawing';
                    case 'HandsUp':
                        return 'handsUp';
                    case 'Chameleon':
                        return 'chameleon';
                    case 'RepeatAfterMe':
                        return 'repeatAfterMe';
                    case 'CorrectiveSamples':
                    case 'CorrectiveSamplesWithoutTime':
                    case 'CorrectiveSamplesWithTime':
                        return 'correctiveSamples';
                    case 'ChainsBonusGame':
                    case 'ChainsBonusGameWithTime':
                    case 'ChainsBonusGameWithoutTime':
                        return 'chainsBonusGame';
                    case 'Scout':
                        return 'scout';
                    case 'Diada':
                    case 'DiadaWithTime':
                        return 'diada';
                    case 'Alpari':
                        return 'alpari';
                    case 'EquationMultiplication':
                        return 'equationMultiplication';
                    case 'ChainsReadingEn':
                        return 'chains';
                    case 'CouplesReadingEn':
                    case 'CouplesReadingEnWithTime':
                    case 'CouplesReadingEnWithoutTime':
                        return 'couples';
                    case 'VisionFieldReadingEn':
                        return 'visionField';
                    case 'Alphabet':
                        return 'alphabet';
                    case 'ConnectThePuzzles':
                        return 'connectThePuzzles';
                    default:
                        return this.type;
                }
            },
            async fetchData() {
                if (!this.$offline && this.exerciseId) {
                    this.isLoading = true;
                    try {
                        const [homeworksRes, exerciseRes] = await Promise.allSettled([
                            HomeworkApi.uncompletedHomework(),
                            GameExerciseApi.show(this.exerciseId),
                        ]);

                        // Обработка HomeworkApi (точно как раньше, включая сортировку и ошибки)
                        if (homeworksRes.status === 'fulfilled') {
                            const response = homeworksRes.value;
                            this.homeworks = _.orderBy(response.homeworks, 'date');
                        } else {
                            const errRaw = homeworksRes.reason;
                            let err = errRaw?.response?.data ?? errRaw;
                            if (err && (err.status_code === 403 || err.status_code === 404 || err.status === 404 || err.status === 403)) {
                                this.$router.push({ name: 'dashboard' });
                                this.$toasted.error(err.message);
                            }
                        }

                        if (exerciseRes.status === 'fulfilled') {
                            const data = exerciseRes.value;
                            this.isDisabledOnMobile = GAMES_DISABLED_ON_MOBILE.includes(data.slug);
                            if (!this.isOlympiad && data.source) {
                                this.$store.dispatch('setHomework', data.source);
                                delete data.source;
                            }
                            this.exercise = data;
                            this.setParameters();
                        } else {
                            const errRaw = exerciseRes.reason;
                            let err = errRaw?.response?.data ?? errRaw;
                            if (err && (err.status_code === 403 || err.status_code === 404 || err.status === 404 || err.status === 403)) {
                                this.$router.push({ name: 'dashboard' });
                                this.$toasted.error(err.message);
                            }
                        }
                    } finally {
                        this.isLoading = false;
                    }
                } else if (this.game) {
                    this.isAbleOnMobile = !GAMES_DISABLED_ON_MOBILE.includes(this.game.slug);
                    this.parameters = this.game;
                } else {
                    this.$router.push({ name: 'dashboard' });
                }
            },
            setParameters() {
                this.parameters = this.exercise.parameters['default'];
                for (let key in this.exercise.parameters) {
                    if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)) {
                        this.parameters = this.exercise.parameters[key];
                        this.isLoading = false;
                        break;
                    }
                }
                if (this.exercise.slug === 'Puzzle') {
                    this.setParametersForPuzzleGame();
                } else {
                    this.parameters.slug = this.getType(this.type);
                    this.$store.dispatch('setGame', this.parameters);
                }
            },
            setParametersForPuzzleGame() {
                this.assignPuzzleImage();
                this.$store.dispatch('setPuzzleGame', this.parameters);
                for (let key in this.parameters.games[0].parameters) {
                    if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)) {
                        this.$store.dispatch('setParamsArray', [this.parameters.games[0].parameters[key]]);
                        return;
                    }
                }
                this.$store.dispatch('setParamsArray', [this.parameters.games[0].parameters.default]);
            },
            async assignPuzzleImage() {
                this.parameters.image = await this.getBase64ImageFromUrl(
                    this.$options.filters.apiFile(this.parameters.imageSrc)
                );
            },
        },
        beforeRouteLeave(to, from, next) {
            if (this.$store.state.trainer.game || this.$store.state.games.puzzle) {
                if (!(to.meta.type && ['trainer', 'games'].includes(to.meta.type))) {
                    this.$store.dispatch('setHomework', null);
                    this.$store.dispatch('setPuzzleGame', null);
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        },
        computed: {
            // todo add check for homeworks limit
            isFreeGamePlaytimeLimitIssue () {
                const user = this.user;
                const school = user?.schools?.[0];
                const snapshot = user?.tariffSnapshot;

                if (!this.afterInit || !school || !snapshot || snapshot.playtime == null) return false;

                return !this.homework &&
                    !this.isOlympiad &&
                    TARIFF_IDS_WITH_PLAY_TIME_LIMIT.includes(school.tariffId) &&
                    Number(snapshot.playtime) <= 0;
            },
            translationKey() {
                return _.camelCase(this.type);
            },
            isBonusGames() {
                return (
                    this.type === 'HandsUp' ||
                    this.type === 'MentalDrawing' ||
                    this.type === 'Chameleon' ||
                    this.type === 'RepeatAfterMe'
                );
            },
            route() {
                return {
                    name: `${_.kebabCase(this.type)}:start`,
                    params: {
                        exerciseId: this.exerciseId,
                        homeworkId: this.homeworkId,
                        courseType: this.courseType,
                        sameSettingsAreActive: this.sameSettingsAreActive,
                    },
                };
            },
            doesntHaveOldUncompletedHomework() {
                if (this.isOlympiad) {
                    this.isHomeworkLoading = false;
                    return true;
                }
                if (this.user && this.user.type === 'student' && this.homework) {
                    let has = this.mentalArithmeticHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('mental-arithmetic');
                    has = this.fastReadingHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('fast-reading');
                    has = this.mathMagicHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('math-magic');
                    has = this.memoryDevelopmentHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('memory-development');
                    has = this.multiplicationHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('multiplication');
                    has = this.onlineSchoolHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('reading-en');
                    has = this.readingEnHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('russian-language');
                    has = this.russianLanguageHomeworks.some(homework => {
                        if (!homework.isFromBlockedSchool) {
                            let homeworkDate = moment(homework.date);
                            let currentHomeworkDate = moment(this.homework.date);
                            return (
                                !homework.pivot.isCompleted &&
                                homeworkDate.isBefore(currentHomeworkDate) &&
                                homework.isOverdue
                            );
                        }
                    });
                    has && this.uncompletedHomeworksTypes.push('online-school');
                    this.isHomeworkLoading = false;
                    return !this.uncompletedHomeworksTypes.includes(this.exercise && this.exercise.courseType);
                } else if ((this.user && this.user.type !== 'student') || !this.exerciseId) {
                    this.isHomeworkLoading = false;
                    return true;
                }
            },
            mentalArithmeticHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'mental-arithmetic')) {
                        return homework;
                    }
                });
            },
            fastReadingHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'fast-reading')) {
                        return homework;
                    }
                });
            },
            mathMagicHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'math-magic')) {
                        return homework;
                    }
                });
            },
            memoryDevelopmentHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'memory-development')) {
                        return homework;
                    }
                });
            },
            multiplicationHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'multiplication')) {
                        return homework;
                    }
                });
            },
            readingEnHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'reading-en')) {
                        return homework;
                    }
                });
            },
            russianLanguageHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'russian-language')) {
                        return homework;
                    }
                });
            },
            onlineSchoolHomeworks() {
                return this.homeworks.filter(homework => {
                    if (homework.exercises.every(exercise => exercise.courseType === 'online-school')) {
                        return homework;
                    }
                });
            },
            isAvailableHomework() {
                if (this.isOlympiad) {
                    this.isHomeworkLoading = false;
                    return true;
                }
                if (this.user && this.user.type === 'student' && this.homework && this.exerciseId) {
                    return this.homework.isOverdue;
                } else if ((this.user && this.user.type !== 'student') || !this.exerciseId) {
                    this.isHomeworkLoading = false;
                    return true;
                }
            },
            ...mapState({
                user: state => state.auth.user,
                game: state => state.trainer.game,
                homework: state => state.trainer.homework,
                paramsArray: state => state.trainer.paramsArray,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    .browse-games__container {
        display: flex;
        justify-content: center;
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .browse-games {
        margin: 0;
        padding: 30px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .browse-games__header-text {
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .browse-games__box {
        display: flex;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        flex: 0 1 auto;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }

    .browse-games__one-player {
        max-width: 800px;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        padding: 30px;
        @include media($sm) {
            padding: 30px 60px;
        }
    }

    .browse-games__buttons-container {
        display: flex;
        justify-content: center;
        margin-top: 30px;
    }

    .browse-games__box-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        .browse-games__header-text_green {
            @include stack-space($space-base);
        }
    }

    .settings-container {
        display: flex;
        padding: 10px;
        box-sizing: border-box;
    }

    .settings {
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        padding: 30px 60px;
    }

    .settings-header {
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        margin-bottom: $space-small;
    }

    .buttons {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
            justify-content: center;
        }
    }

    .tip-button {
        width: 170px;
        height: 50px;
        font-size: 15px;
        margin-top: 10px;
        @include media($sm) {
            margin-top: 0;
            margin-left: 30px;
        }
    }
</style>
